import {EQSpecification, initialSpecification} from "../equipment/EQSpecification";
import {EQChangeRequest, initializeChangeRequest} from "./EQChangeRequest";

export interface EQWorkOrder {
  // --------------------------------------------------- DB Properties ----------------------------------------------
  // Identity & Index
  uid: number;
  guid: string;
  specificationUID: number; // 기기 UID - EQSpecification
  writerUID: number; // 작성자 UID - EQUser
  companyUID: number; // 업체 UID - EQCompany
  writerDepartmentUID: number; // 작성 부서 UID - EQDepartment
  processDepartmentUID: number; // 진행 부서 UID - EQDepartment

  checkType: number; // 기기점검 구분  0 - 기타, 1 - 점검, 2 - 예방, 3 - 예측, 4 - 고장
  requestDate: Date | string; // 요청 날짜

  priority: number; // 우선순위
  isChangable: boolean; // 변경 가능 여부

  statusIndex: number; // 상태 -  요청 - 0, 접수/진행 - 1, 반려 - 2, 지연 - 3, 완료 - 4

  // File - 2020-07-29 New Entry
  evaluation1File: string; // 평가 자료 파일1
  evaluation2File: string; // 평가 자료 파일2
  education1File: string; // 교육 자료 파일1
  education2File: string; // 교육 자료 파일2
  fireWorkFile: string; // 화기 작업 자료 파일
  generalFile: string; // 일반 작업 자료 파일
  changeRequestFile: string; // 변경 요구서 파일
  preCheckFile: string; // 사전 점검 파일
  changeEvalFile: string; // 변경 평가 파일

  // Entry Field
  serialNo: number; // 일련번호
  writeDate: Date | string; // 작성일
  department: string; // 부서명
  writerName: string; // 작성자

  // Specification
  type: number; // Deprecated - 중복
  //IdentifyNo: string;  // Deprecated - 중복
  //SpecName: string;  // Deprecated - 중복
  dangerLevel: string; // Deprecated - 중복 - EQLevel

  // Statistics
  statisticsCategory: number; // 통계번호 - 유형
  statisticsItem: number; // 통계번호 - 장치
  statistics2: number; // 통계번호 - 상태

  sCategoryName: string; // Deprecated - 중복
  sItemName: string; // Deprecated - 중복
  statistics2Name: string; // Deprecated - 중복

  // Text
  requestContent: string; // 요청 내용
  repairContent: string; // 수리 내용
  punchContent: string; // Deprecated  NOT USED
  rejectContent: string; // 반려 내용
  delayContent: string; // 지연 내용

  // Receive Phase 설비점검이력
  receiverUID: number; // 수신자 UID - EQUser UID
  repairCompany: string; // 협력업체명
  isOutsourcing: boolean; // 외부업체 여부
  isChanged: boolean; // 변경사항 // Deprecated - IsChangable 과 중복

  evaluation1: Date | string; // 평가 일시 1
  evaluation2: Date | string; // 평가 일시 2
  education1: Date | string; // 교육 일시 1
  education2: Date | string; // 교육 일시 2

  // 수동 체크
  isStopElectricity: boolean; // 정전
  isHeight: boolean; // 고소
  isClosed: boolean; // 밀폐
  isExcavation: boolean; // 굴착
  isHeavy: boolean; // 중장비
  isRadiation: boolean; // 방사선

  // Process Stage Properties
  estimatedDate: Date | string; // 완료 예정일자 - 예상시작일자 - 요청일자가 기본값
  processorUID: number; // 진행자 UID - EQUser UID
  startTime: number; // Deprecated - 소요시간으로 대체
  endTime: number; // Deprecated - 소요시간으로 대체
  workedHours: number; // 작업 소요 시간
  cost: number;

  // Complete Phase
  preWork: Date | string; // Deprecated = CompletedDate로 변경
  attachment: string; // 자료등록 //
  isLastConfirmed: boolean; // 관리자확인
  externalComment: string; // 비고
  startDate: Date | string; // 시작일
  completeDate: Date | string; //  - 완료일

  //Attachments
  preFile: string; // - 개선 전 파일
  postFile: string; // - 개선 후 파일
  etcFile: string; // 관련자료

  //변경이력서
  changeRequestUID: number; // 변경 이력서 UID - EQChangeRequest UID (추후)

  entryDate: Date | string; // 작성일

  // -------------------------------------------------- No DB -------------------------------------------;
  receiverName: string; // 접수자

  // Base64
  evaluation1FileBase64: string;
  evaluation2FileBase64: string;
  education1FileBase64: string;
  education2FileBase64: string;
  fireWorkFileBase64: string;
  generalFileBase64: string;
  changeRequestFileBase64: string;
  preCheckFileBase64: string;
  changeEvalFileBase64: string;
  attachmentBase64: string;
  preFileBase64: string;
  postFileBase64: string;
  etcFileBase64: string;

  // isNoneEvaluation1: boolean; // ----------- DB에서 제외 - 파일 유무로 대체
  // isNoneEvaluation2: boolean; // ----------- DB에서 제외 - 파일 유무로 대체
  // isNoneEducation1: boolean; // ----------- DB에서 제외 - 파일 유무로 대체
  // isNoneEducation2: boolean; // ----------- DB에서 제외 - 파일 유무로 대체
  // isNonePreWork: boolean; // Deprecated

  // isFireDevice: boolean; // ----- DB에서 제외 - 파일 유무로 대체
  // isGeneral: boolean; // ---------- DB에서 제외 - 파일 유무로 대체
  // isPreCheck: boolean; // -------- DB에서 제외 - 파일 유무로 대체
  // ------------------------------------------------------ NO DB Properties -----------------------------------------

  // Nested Object
  specification: EQSpecification; // 설비 유지
  changeRequest: EQChangeRequest; // 변경 요구서
}

export const initializeWorkOrder: EQWorkOrder = {
  // --------------------------------------------------- DB Properties ----------------------------------------------
  // Identity & Index
  uid: 0,
  guid: "00000000-0000-0000-0000-000000000000",
  specificationUID: 0, // 기기 UID - EQSpecification
  writerUID: 0, // 작성자 UID - EQUser
  companyUID: 0, // 업체 UID - EQCompany
  writerDepartmentUID: 0, // 작성 부서 UID - EQDepartment
  processDepartmentUID: 0, // 진행 부서 UID - EQDepartment

  checkType: 0, // 기기점검 구분
  requestDate: new Date(), // 요청 날짜

  priority: 0, // 우선순위
  isChangable: false, // 변경 가능 여부

  statusIndex: 0, // 상태 -  요청 - 0, 접수/진행 - 1, 반려 - 2, 지연 - 3, 완료 - 4

  // File - 2020-07-29 New Entry
  evaluation1File: "", // 평가 자료 파일1
  evaluation2File: "", // 평가 자료 파일2
  education1File: "", // 교육 자료 파일1
  education2File: "", // 교육 자료 파일2
  fireWorkFile: "", // 화기 작업 자료 파일
  generalFile: "", // 일반 작업 자료 파일
  changeRequestFile: "", // 변경 요구서 파일
  preCheckFile: "", // 사전 점검 파일
  changeEvalFile: "", // 변경 평가 파일

  // Entry Field
  serialNo: 0, // 일련번호
  writeDate: new Date(), // 작성일
  department: "", // 부서명
  writerName: "", // 작성자

  // Specification
  type: 0, // Deprecated - 중복
  //IdentifyNo: "",  // Deprecated - 중복
  //SpecName: "",  // Deprecated - 중복
  dangerLevel: "", // Deprecated - 중복 - EQLevel

  // Statistics
  statisticsCategory: 0, // 통계번호 - 유형
  statisticsItem: 0, // 통계번호 - 장치
  statistics2: 0, // 통계번호 - 상태

  sCategoryName: "", // Deprecated - 중복
  sItemName: "", // Deprecated - 중복
  statistics2Name: "", // Deprecated - 중복

  // Text
  requestContent: "", // 요청 내용
  repairContent: "", // 수리 내용
  punchContent: "", // Deprecated  NOT USED
  rejectContent: "", // 반려 내용
  delayContent: "", // 지연 내용

  // Receive Phase 설비점검이력
  receiverUID: 0, // 수신자 UID - EQUser UID
  repairCompany: "", // 협력업체명
  isOutsourcing: false, // 외부업체 여부
  isChanged: false, // 변경사항 // Deprecated - IsChangable 과 중복

  evaluation1: new Date(), // 평가 일시 1
  evaluation2: new Date(), // 평가 일시 2
  education1: new Date(), // 교육 일시 1
  education2: new Date(), // 교육 일시 2

  // 수동 체크
  isStopElectricity: false, // 정전
  isHeight: false, // 고소
  isClosed: false, // 밀폐
  isExcavation: false, // 굴착
  isHeavy: false, // 중장비
  isRadiation: false, // 방사선

  // Process Stage Properties
  estimatedDate: new Date(), // 완료 예정일자 - 예상시작일자 - 요청일자가 기본값
  processorUID: 0, // 진행자 UID - EQUser UID
  startTime: 0, // Deprecated - 소요시간으로 대체
  endTime: 0, // Deprecated - 소요시간으로 대체
  workedHours: 0, // 작업 소요 시간
  cost: 0,

  // Complete Phase
  preWork: new Date(), // Deprecated = CompletedDate로 변경
  attachment: "", // 자료등록 //
  isLastConfirmed: false, // 관리자확인
  externalComment: "", // 비고
  startDate: new Date(), // 시작일
  completeDate: new Date(), //  - 완료일

  //Attachments
  preFile: "", // - 개선 전 파일
  postFile: "", // - 개선 후 파일
  etcFile: "", // 관련자료

  //변경이력서
  changeRequestUID: 0, // 변경 이력서 UID - EQChangeRequest UID (추후)

  entryDate: new Date(), // 작성일

  // -------------------------------------------------- No DB -------------------------------------------
  receiverName: "",

  // Base64
  evaluation1FileBase64: "",
  evaluation2FileBase64: "",
  education1FileBase64: "",
  education2FileBase64: "",
  fireWorkFileBase64: "",
  generalFileBase64: "",
  changeRequestFileBase64: "",
  preCheckFileBase64: "",
  changeEvalFileBase64: "",
  attachmentBase64: "",
  preFileBase64: "",
  postFileBase64: "",
  etcFileBase64: "",

  // isNoneEvaluation1: false, // ----------- DB에서 제외 - 파일 유무로 대체
  // isNoneEvaluation2: false, // ----------- DB에서 제외 - 파일 유무로 대체
  // isNoneEducation1: false, // ----------- DB에서 제외 - 파일 유무로 대체
  // isNoneEducation2: false, // ----------- DB에서 제외 - 파일 유무로 대체
  // isNonePreWork: false, // Deprecated

  // isFireDevice: false, // ----- DB에서 제외 - 파일 유무로 대체
  // isGeneral: false, // ---------- DB에서 제외 - 파일 유무로 대체
  // isPreCheck: false, // -------- DB에서 제외 - 파일 유무로 대체
  // ------------------------------------------------------ NO DB Properties -----------------------------------------

  // Nested Object
  specification: {...initialSpecification}, // 설비 유지
  changeRequest: initializeChangeRequest(),
};

export interface WorkOrderListParams {
  page: number;
  token: string;
  rows?: number;
  statusIndex: number; // 상태 (-1은 전체)
  specificationTypeIndex: number; // 설비분류 (-1은 전체)
  identifyNo: string;
  departmentUID: number; // 작성부서 UID (-1은 전체)
  writerName: string;
  specificationName: string;
  level: string;
  startDate: Date | string | null;
  endDate: Date | string | null;
}

export const initializeWorkOrderListParams = {
  page: 1,
  token: "",
  rows: 20,
  statusIndex: -1, // 상태 (-1은 전체)
  specificationTypeIndex: -1, // 설비분류 (-1은 전체)
  identifyNo: "",
  departmentUID: -1, // 작성부서 UID (-1은 전체)
  writerName: "",
  specificationName: "",
  level: "",
  startDate: null,
  endDate: null,
};

export const statusNames = ["요청", "접수/진행", "반려", "지연", "완료"];
export const checkTypeNames = ["기타", "점검", "예방", "예측", "고장"];

// 일련번호 구하기
export const getSerialNumber = (workOrder: EQWorkOrder): string => {
  if (workOrder) {
    const date = new Date(workOrder.startDate);
    if (date)
      return `${date.getFullYear()}-${workOrder.department}-${workOrder.serialNo
        .toString()
        .padStart(4, "0")}`;
  }
  return "";
};
